import LOGO from "../../PFC_Images/PFC46.png";
import ARM from "../../PFC_Images/NCFP.JPG"

const GolfTwo = () => {
    return (
        <div className="w-full h-full relative bg-black text-black">
            
            <img
                src={ARM}
                alt="background"
                className={`absolute duration-1000 opacity-70 inset-0 w-full h-full object-cover`}
            />
            
            <img
                src={LOGO}
                alt="background"
                className={`z-50 absolute top-2 left-2 size-24 inset-0 object-cover`}
            />
            
            <div className={`z-50 w-full h-full flex items-center justify-center`}>
                
                <div className={`z-50 w-2/3 flex flex-col backdrop-blur-sm p-4 rounded-2xl drop-shadow-2xl`}>
                    
                    <span className={`text-2xl flex flex-col font-bold text-white`}>
                        <span className={``}>Built on Expertise</span>
                        <span className={``}>Driven by Partnership.</span>
                    </span>
                    <span className={`mt-3 text-sm text-gray-200 italic`}>Our sales team is made up of professionals who put consultation first. We believe in building long-term relationships by offering honest guidance, tailored recommendations, and hands-on support—so you can make confident decisions for your turf program every step of the way.</span>
                </div>
            
            </div>
            
        
        </div>
    )
}

export default GolfTwo;
